import React, { useContext } from 'react';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

import EventTypeTag from '@components/EventDetails/EventTypeTag';
import NwEllipsis from '@components/Gui/NwEllipsis';
import ProjectLine from '@components/ProjectLine/ProjectLine';
import EventTimeDisplay from '@components/Schedule/Agenda/EventTimeDisplay';

const EventContainer = styled.div`
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    border-bottom: ${(props) => props.theme.DefaultBorder};
    min-height: 3rem;
    ${(props) => (props.cancel ? props.theme.RedLineThrough(1) : 'text-decoration: none;')}

    @media only screen and (max-width: 480px) {
        flex-wrap: wrap;
    }

    .agenda-event-time {
        text-transform: uppercase;
        padding: 0.25em 0.5em 0.25em 0;
        white-space: nowrap;
        min-width: 8.5rem;
        text-align: right;
        @media only screen and (max-width: 480px) {
            text-align: left;
            width: 100%;
            padding: 0.25em 0.5em;
            border-bottom: ${(props) => props.theme.DefaultBorder};
        }
        .start-end-time {
            display: flex;
            flex-direction: column;

            @media only screen and (max-width: 480px) {
                flex-direction: row;
                .start-time {
                    margin-right: 10px;
                }
            }
        }
        span {
            display: block;
            font-size: 1rem;

            &.start-time {
                font-weight: bold;
            }
            &.all-day {
                font-weight: normal;
                font-size: ${(props) => props.theme.FontSizeSm};
            }
            &.reminder {
                font-weight: bold;
                color: ${(props) => props.theme.DangerColor};
                font-size: 0.6rem;
            }
        }
        small {
            display: block;
            font-weight: normal;
            font-size: ${(props) => props.theme.FontSizeSm};
        }
        div.end-date {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            svg {
                margin-right: 1em;
            }
        }
        div.started-date {
            display: block;
        }
    }

    .agenda-event-content {
        border-left: ${(props) => props.theme.DefaultBorder};
        padding: 0.5em;
        min-height: 3rem;
        flex: 1 0 0;
        opacity: ${(props) => props.isAvailable && 0.5};

        @media only screen and (max-width: 480px) {
            width: 100%;
            border-left: none;
        }

        .agenda-event-name {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: column;
            padding: 0.15rem 0;

            .ant-tag {
                ${(props) => (props.cancel ? props.theme.RedLineThrough(1) : 'text-decoration: none;')}
            }
            .netwalk-event-tag {
                margin-top: 0.25rem;
                margin-bottom: 0.15rem;
            }

            .agenda-event-nametext {
                font-weight: bold;
                font-size: 0.8rem;
                line-height: ${(props) => props.theme.FontSizeSm};
                text-transform: uppercase;
                ${(props) => (props.cancel ? props.theme.RedLineThrough(1) : 'text-decoration: none;')}
            }
        }

        .agenda-event-description {
            padding-right: 2rem;
            font-size: ${(props) => props.theme.FontSizeSm};
            line-height: 1.1em;
        }

        .agenda-event-models-list {
            padding: 0.15rem 0;
            font-size: ${(props) => props.theme.FontSizeSm};
            text-transform: capitalize;
            em {
                font-style: normal;
            }
        }
        .agenda-event-models-exceptions {
            padding: 0.15rem 0;
            font-size: ${(props) => props.theme.FontSizeSm};
            text-transform: capitalize;
            strong {
                display: block;
                text-transform: uppercase;
            }
            em {
                font-style: normal;
            }
        }
    }
`;

const ModelAvailabilityDrawerEvent = ({ event, currentDate }) => {
    const { cachedList } = useContext(ListContext);
    const eventtype = cachedList.eventTypes.items.find((et) => et.code === event.TypeName);

    return (
        <EventContainer key={`${event.TypeName}-${event.ID}`} cancel={event.Cancel}>
            <EventTimeDisplay event={event} eventType={eventtype} currentDate={currentDate} />
            <div className="agenda-event-content">
                {event.Project && <ProjectLine small project={event.Project} ellipsis mg="0" />}
                <div className="agenda-event-name">
                    <EventTypeTag event={event} />
                    <div className="agenda-event-nametext">{event.Name}</div>
                </div>
                {eventtype.id !== 150 && (
                    <div className="agenda-event-description">
                        <NwEllipsis noFontSize text={event.Description} rows={2} />
                    </div>
                )}
            </div>
        </EventContainer>
    );
};

export default ModelAvailabilityDrawerEvent;
